let DataService = {};

DataService.Languages = [{
    id: 'vi',
    name: 'Tiếng Việt'
}, {
    id: 'en',
    name: 'Tiếng Anh'
}];
DataService.gioiTinhRegister = [{
        code: 1,
        text: "Nữ"
    },
    {
        code: 2,
        text: "Nam"
    },
    {
        code: 3,
        text: "Khác"
    }
];
DataService.loaiHinhRegister = [{
        code: "international_travel",
        text: "Lữ hành quốc tế"
    },
    {
        code: "domestic_travel",
        text: "Lữ hành nội địa"
    },
    {
        code: "hotel",
        text: "Khách sạn"
    },
    {
        code: "tourist_villa",
        text: "Biệt thự du lịch"
    },
    {
        code: "tourist_apartment",
        text: "Căn hộ du lịch"
    },
    {
        code: "tourist_cruise",
        text: "Tầu thủy lưu trú du lịch"
    },
    {
        code: "camping",
        text: "Bãi cắm trại du lịch"
    },
    {
        code: "motel",
        text: "Nhà nghỉ du lịch"
    },
    {
        code: "homestay",
        text: "Nhà ở có phòng cho khách du lịch thuê/Homestay"
    },
    {
        code: "tourist_carriers",
        text: "Vận tải khách"
    },
    {
        code: "shopping",
        text: "Điểm mua sắm"
    },
    {
        code: "restaurant",
        text: "Nhà hàng"
    },
    {
        code: "tourist_area",
        text: "Khu du lịch"
    },
    {
        code: "state_management_agency",
        text: "Cơ quan quản lý nhà nước"
    },
    {
        code: "tourist_attraction",
        text: "Điểm du lịch"
    },
    {
        code: "entertainment",
        text: "Địa điểm vui chơi, giải trí"
    },
    {
        code: "others",
        text: "Khác"
    }
];
DataService.gioiTinh = [{
        id: 1,
        text: "Nữ"
    },
    {
        id: 2,
        text: "Nam"
    },
    {
        id: 3,
        text: "Chưa có thông tin"
    },
    {
        id: 4,
        text: "Khác"
    }
];

DataService.loaiGiayTo = [{
        id: "CMT",
        text: "Chứng minh thư"
    },
    {
        id: "CCCD",
        text: "Căn cước công dân"
    },
    {
        id: "PASSPORT",
        text: "Hộ chiếu"
    }
];

DataService.loaiDinhDang = [{
        code: "hoten",
        text: "Họ Tên"
    },
    {
        code: "tenho",
        text: "Tên Họ"
    }
];

DataService.loaiTheHDV = [{
        code: "quoc_te",
        text: "Thẻ quốc tế"
    },
    {
        code: "noi_dia",
        text: "Thẻ nội địa"
    },
    {
        code: "tai_diem",
        text: "Thẻ tại điểm"
    }
];

DataService.trangThaiTheHDV = [{
        code: "active",
        text: "Active"
    },
    {
        code: "expired",
        text: "Đã hết hạn"
    },
    {
        code: "not_active",
        text: "Không hoạt động"
    }
];
DataService.loaiNhomPhanHoi = [{
        code: "kdl",
        text: "Khách du lịch"
    },
    {
        code: "hdv",
        text: "Hướng dẫn viên"
    },
    {
        code: "ddat",
        text: "Điểm đến"
    }
];

DataService.doiTuongPhanHoi = [{
        code: "DNLH",
        text: "Doanh nghiệp lữ hành"
    },
    {
        code: "TOUR",
        text: "Tour"
    },
    {
        code: "HDV",
        text: "Hướng dẫn viên"
    },
    {
        code: "CSLT",
        text: "Cơ sở lưu trú"
    },
    {
        code: "DDAT",
        text: "Điểm đến"
    }
];

DataService.doiTuongHienThi = [{
        code: "tourist",
        text: "App khách du lịch"
    },
    {
        code: "tourguide",
        text: "App hướng dẫn viên"
    }
];

DataService.trangThaiXL = [{
        code: "new",
        text: "Mới"
    },
    {
        code: "processing",
        text: "Đang xử lý"
    },
    {
        code: "processed",
        text: "Đã xử lý"
    }
];

DataService.accountRoles = [
    // {
    //   code: 'Admin',
    //   text: "Quản trị hệ thống"
    // },
    {
        code: "*",
        text: "*"
    },
    {
        code: "Officer",
        text: "Cơ quan quản lý"
    },
    {
        code: "TourAgent",
        text: "Công ty lữ hành"
    },
    {
        code: "TourGuide",
        text: "Hướng dẫn viên du lịch"
    },
    {
        code: "HqsManager",
        text: "Duyệt dịch vụ du lịch clc"
    },
    {
        code: "HqsContributor",
        text: "Đăng dịch vụ du lịch clc"
    },
    {
        code: "TCQLTT",
        text: "Tổng cục quản lý thị trường"
    },
    {
        code: 'User',
        text: "Khách du lịch"
    },
    {
        code: "VNATAdmin",
        text: "Quản trị Việt Nam an toàn"
    },
    {
        code: "SVHTT",
        text: "Sở VHTT"
    },
    {
        code: "PVHTT",
        text: "Phòng VHTT"
    },
    {
        code: "TourismInspector",
        text: "Thanh tra du lịch"
    },
];

DataService.accountRolesSearch = [{
        code: "Officer",
        text: "Cơ quan quản lý"
    },
    {
        code: "TourAgent",
        text: "Công ty lữ hành"
    },
    {
        code: "User",
        text: "Khách du lịch"
    },
    {
        code: "TourGuide",
        text: "Hướng dẫn viên du lịch"
    },
    {
        code: "HqsManager",
        text: "Duyệt dịch vụ du lịch clc"
    },
    {
        code: "HqsContributor",
        text: "Đăng dịch vụ du lịch clc"
    },
    {
        code: "TCQLTT",
        text: "Tổng cục quản lý thị trường"
    },
    {
        code: "VNATAdmin",
        text: "Quản trị Việt Nam an toàn"
    },
    {
        code: "SVHTT",
        text: "Sở VHTT"
    },
    {
        code: "PVHTT",
        text: "Phòng VHTT"
    },
    {
        code: "TourismInspector",
        text: "Thanh tra du lịch"
    },
];

DataService.accountRolesCreate = [{
        code: "Officer",
        text: "Cơ quan quản lý"
    },
    {
        code: "HqsManager",
        text: "Duyệt dịch vụ du lịch clc"
    },
    {
        code: "HqsContributor",
        text: "Đăng dịch vụ du lịch clc"
    },
    {
        code: "TCQLTT",
        text: "Tổng cục quản lý thị trường"
    },
    {
        code: "VNATAdmin",
        text: "Quản trị Việt Nam an toàn"
    },
    {
        code: "SVHTT",
        text: "Sở VHTT"
    },
    {
        code: "PVHTT",
        text: "Phòng VHTT"
    },
    {
        code: "TourismInspector",
        text: "Thanh tra du lịch"
    },

];

DataService.DoDaiSoThe = 16;

DataService.rolesInForm = [{
        code: "0",
        text: "Read"
    },
    {
        code: "1",
        text: "Create"
    },
    {
        code: "2",
        text: "Update"
    },
    {
        code: "3",
        text: "Delete"
    }
];

DataService.giaTriDanhGiaThanhPhan = [{
        code: -1,
        text: "Kém"
    },
    {
        code: 0,
        text: "Trung bình"
    },
    {
        code: 1,
        text: "Tốt"
    }
];

DataService.trangThaiHoatDong = [{
        code: "false",
        text: "Hoạt động"
    },
    {
        code: "true",
        text: "Ngừng hoạt động"
    }
];

DataService.smsType = [
    {
        id: "all",
        value:  "Tất cả"
    },
    {
        id: "otp",
        value:  "Mã OTP"
    },
    {
        id: "password",
        value:  "Mật khẩu"
    },
]

DataService.implementationObject = [
    {
        id: "Tourist",
        value:  "Khách du lịch"
    },
    {
        id: "SafePlace",
        value:  "Điểm đến"
    },
]

DataService.listXepHang = [
    {
        value: "05",
        label: "5 sao"
    },
    {
        value: "04",
        label: "4 sao"
    },
    {
        value: "03",
        label: "3 sao"
    },
    {
        value: "02",
        label: "2 sao"
    },
    {
        value: "01",
        label: "1 sao"
    },
    {
        value: "00",
        label: "Không xếp hạng"
    },
]

export default DataService;
